import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-6 bg-navy-900 border-y border-slate-800" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="bg-navy-800 p-8 md:p-12 rounded-2xl border border-slate-700 text-center relative overflow-hidden" data-id="element-159">
            <ShieldIcon className="absolute -right-10 -top-10 w-40 h-40 text-slate-700/20 pointer-events-none" data-id="element-160" />

            <h2 className="font-serif text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-161">
              La Ventana de los 15 Minutos
            </h2>

            <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-162">
              No prometemos que nunca más te dolerá la cabeza. Prometemos que la
              próxima vez que el dolor intente tumbarte, tendrás una herramienta
              física para detener la intensidad en seco y evitar que la crisis
              escale a un nivel incapacitante.
            </p>

            <div className="inline-flex items-center text-teal-400 font-medium" data-id="element-163">
              <ShieldIcon className="w-5 h-5 mr-2" data-id="element-164" />
              <span data-id="element-165">Nuestra Promesa Honesta</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}